// A7 denetim (probe D): ücret koşulu yalnız beyan edildiyse bilinir. Backend kartı bilinmeyeni `null` gönderir.
// Eski/önbellekteki kayıtlarda boş çalışma modeli (yalnız "görüşmeye açık" dahil) veya depozito beyanı olmayan `false`
// da "bilinmiyor" okunur — DNA okuyucusuyla (dna_schema.dna_from_record) aynı yorum. true | false | null döner.
export const termState = (venue, flag) => {
  const value = venue?.[flag];
  if (value === true) return true;
  if (value !== false) return null;
  if (flag === 'has_deposit') return venue.deposit_stated === false ? null : false;
  if (Array.isArray(venue.work_models) && !venue.work_models.some(model => model !== 'gorusmeye_acik')) return null;
  return false;
};

export const TERM_FIELDS = [['has_fixed_rent', 'fixed_rent_amount', 'Mekân kirası'], ['has_min_spending', 'min_spending_amount', 'Minimum harcama'],
  ['has_deposit', 'deposit_amount', 'Depozito']];
